import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { ArrowBack, CheckCircle } from "@material-ui/icons";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import PaymentMethodList from "../PaymentMethods/PaymentMethodList";
import {
  setDefaultCreditCardOfUser,
  updateSoothePassPaymentMethod,
} from "../Shared/Helpers";
import ErrorModal from "../Shared/ErrorModal";

class ChangePaymentMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPaymentMethod: null,
      setAsDefault: false,
      isUpdatingPayment: false,
      showSuccessBanner: false,
      successMessage: "",
      showErrorModal: false,
      error: "",
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
  }

  handlePaymentMethodSelect = (method) => {
    this.setState({ selectedPaymentMethod: method });
  };

  handleSavePaymentMethod = () => {
    const { selectedPaymentMethod, setAsDefault } = this.state;
    if (!selectedPaymentMethod) return;

    const clientId = get(this.props, "client.user_id");
    const subscriptionId = get(
      this.props,
      "client.soothe_pass.soothe_pass_subscription_id"
    );

    if (!clientId || !subscriptionId) {
      console.error("Missing required data for payment method update");
      return;
    }

    this.setState({ isUpdatingPayment: true });

    // Update the subscription payment method
    updateSoothePassPaymentMethod(
      clientId,
      subscriptionId,
      {
        credit_card_id: selectedPaymentMethod.id,
        city_id: get(this.props, "client.soothe_pass.city_id", ""),
        subscription_tier_id: get(
          this.props,
          "client.soothe_pass.subscription_tier_id",
          ""
        ),
      },
      (response) => {
        // If user also wants to set as default, do that as well
        if (setAsDefault) {
          setDefaultCreditCardOfUser(
            selectedPaymentMethod.id,
            (defaultResponse) => {
              this.setState({
                isUpdatingPayment: false,
                showSuccessBanner: true,
                successMessage: "Default payment method saved",
              });
              // Auto-dismiss banner and reload after delay
              setTimeout(() => {
                this.setState({ showSuccessBanner: false });
                window.location.reload();
              }, 3000);
            },
            (error) => {
              this.setState({ isUpdatingPayment: false });
              console.error("Failed to set as default payment method:", error);
              // Still show success for subscription update even if default setting failed
              this.setState({
                showSuccessBanner: true,
                successMessage: "Payment method updated successfully",
              });
              // Auto-dismiss banner and reload after delay
              setTimeout(() => {
                this.setState({ showSuccessBanner: false });
                window.location.reload();
              }, 3000);
            }
          );
        } else {
          this.setState({
            isUpdatingPayment: false,
            showSuccessBanner: true,
            successMessage: "Payment method updated successfully",
          });
          // Auto-dismiss banner and reload after delay
          setTimeout(() => {
            this.setState({ showSuccessBanner: false });
            window.location.reload();
          }, 3000);
        }
      },
      (error) => {
        this.setState({ isUpdatingPayment: false });
        console.error("Failed to update subscription payment method:", error);
        // Show error feedback to user
        this.setState({
          showErrorModal: true,
          error: "Failed to update payment method. Please try again.",
        });
      }
    );
  };

  closeSuccessBanner = () => {
    this.setState({
      showSuccessBanner: false,
      successMessage: "",
    });
    if (this.props.handleBack) {
      this.props.handleBack(true);
    }
  };

  closeErrorModal = () => {
    this.setState({
      showErrorModal: false,
      error: "",
    });
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "659px",
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div>
          <button
            onClick={() => this.props.handleBack && this.props.handleBack()}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "14px",
              borderRadius: "48px",
              width: "24px",
              height: "44px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ArrowBack style={{ fontSize: "20px", color: "#323232" }} />
          </button>
        </div>
        <div
          style={{
            fontFamily: "Poppins",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "1.33em",
            color: "#000000",
          }}
        >
          Change Payment Method
        </div>

        {/* Payment Methods List using shared component */}
        <PaymentMethodList
          showAdd={true}
          showDelete={true}
          showDefault={false}
          onSelect={this.handlePaymentMethodSelect}
          selectedId={
            this.state.selectedPaymentMethod
              ? get(this.state, "selectedPaymentMethod.id")
              : get(this.props, "client.soothe_pass.credit_card_id", null)
          }
        />

        {/* Success Banner */}
        {this.state.showSuccessBanner ? (
          <div
            style={{
              alignSelf: "stretch",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                alignSelf: "stretch",
                backgroundColor: "#05944F",
                borderRadius: "4px",
              }}
            >
              {/* Artwork frame */}
              <div
                style={{
                  display: "flex",
                  padding: "16px",
                }}
              >
                <CheckCircle
                  style={{
                    fontSize: "24px",
                    color: "#FFFFFF",
                    width: "24px",
                    height: "24px",
                  }}
                />
              </div>
              {/* Text frame */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "stretch",
                  alignItems: "stretch",
                  padding: "16px 16px 16px 0px",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "1.5em",
                    textAlign: "left",
                    color: "#FFFFFF",
                    flex: 1,
                    alignSelf: "stretch",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {this.state.successMessage}
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* Set as Default Checkbox - only show when not showing success banner */
          this.state.selectedPaymentMethod &&
          !get(this.state, "selectedPaymentMethod.default", null) && (
            <div>
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onClick={() =>
                  this.setState({ setAsDefault: !this.state.setAsDefault })
                }
              >
                {this.state.setAsDefault ? (
                  <CheckBoxIcon
                    style={{ fontSize: "24px", color: "#586B94" }}
                  />
                ) : (
                  <CheckBoxOutlineBlankIcon
                    style={{ fontSize: "24px", color: "#586B94" }}
                  />
                )}
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "1.43em",
                    color: "#000000",
                  }}
                >
                  Set as default payment method
                </div>
              </div>
            </div>
          )
        )}

        {/* Save Button - Docked Footer Style */}
        <div
          style={{
            borderTop: "1px solid #E2E2E2",
            padding: "16px 0",
            marginTop: "auto",
          }}
        >
          <div style={{ padding: "0 16px" }}>
            <button
              onClick={this.handleSavePaymentMethod}
              disabled={
                !this.state.selectedPaymentMethod ||
                this.state.isUpdatingPayment
              }
              style={{
                width: "100%",
                maxWidth: "343px",
                margin: "0 auto",
                display: "block",
                borderRadius: "30px",
                backgroundColor:
                  this.state.selectedPaymentMethod &&
                !this.state.isUpdatingPayment
                    ? "#F58266"
                    : "#F6F6F6",
                color:
                  this.state.selectedPaymentMethod &&
                  !this.state.isUpdatingPayment
                    ? "#FFFFFF"
                    : "#AFAFAF",
                fontSize: "18px",
                fontWeight: "500",
                padding: "16px 20px",
                border: "none",
                cursor:
                  this.state.selectedPaymentMethod &&
                  !this.state.isUpdatingPayment
                    ? "pointer"
                    : "not-allowed",
                transition: "all 0.3s ease",
              }}
            >
              {this.state.isUpdatingPayment ? "Saving..." : "Save"}
            </button>
          </div>
        </div>


        {/* Error Modal */}
        {this.state.showErrorModal && (
          <ErrorModal 
            isOpen={this.state.showErrorModal} 
            close={this.closeErrorModal}
          >
            <p>{this.state.error}</p>
          </ErrorModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps)(ChangePaymentMethod);
